import { PieSeriesOption } from "echarts";
import { SeriesTypeEnum } from "../enums/SeriesType.enum";
import { EchartsGraphConfig } from "../type/EchartGraphConfig";
import { Series } from "../type/Series";
import { Trigger } from "../type/Trigger";
import { EchartsGraph } from "./echarts-graph";

export class EchartsPieGraph extends EchartsGraph{

    override trigger: Trigger = 'item';

    serie: PieSeriesOption = {
        name: '',
        type: SeriesTypeEnum.PIE,
        data: [],
        radius: '50%',
        emphasis: {
            itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
        }
    };

    constructor(config: EchartsGraphConfig){
        super(config);
        this.options.yAxis = [];
        if (config.tooltip === undefined || config.tooltip === true) this.options.tooltip = this.setTooltip();
    }

    public override setSimpleGraphSeries(): void {
        throw new Error('Pie serie should be set with setPieSerie()');
    }

    public setPieSerie(serie: Series){
        this.serie.name = serie.name;
        this.serie.data = serie.data;
        this.setSeries([this.serie])
    }

    public changePieRadius(radius: number, type: 'px' | '%' = '%'){
        const rad = radius + type;
        this.serie.radius = rad;
    }
}